/**
 * Created by Ning Jiang on 2024-08-23.
 */

export class CylinderFeatureName {

    public static readonly XSPLIT:string = "XSPLIT";
    public static readonly IN_XSPLIT:string = "IN_XSPLIT";
    public static readonly TURN_WILD:string = "TURN_WILD";
    public static readonly IN_WILD:string = "IN_WILD";
    public static readonly MID_EXPAND:string = "MID_EXPAND";
    public static readonly MID_MULTI:string = "MID_MULTI";
    public static readonly ADD_MULTI:string = "ADD_MULTI";
    public static readonly UPDATE_FS_LEVEL:string = "UPDATE_FS_LEVEL";
}